export default __webpack_public_path__ + "static/globe-3bc569e7c75be4e1e8280d0fd4336920.png";